export default __webpack_public_path__ + "svg/calendar/2027/8/noviembre.svg?bb3558cc";